module.exports = __webpack_public_path__ + "/img/Standoff-Female-YD0OSR.svg";